import React, { FC } from "react";
import NiceModal, { NiceModalHocProps, useModal } from "@ebay/nice-modal-react";
import KC_Button, {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../designsystem/KC_Button/KC_Button";
import { tt } from "../../../utils/i18n/i18n";
import KC_Modal from "../../../designsystem/KC_Modal/KC_Modal";
import KC_Heading2 from "../../../designsystem/typography/KC-Heading/KC_Heading2";

interface Props {
  id?: string;
  title: string;
  children: string | React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  hideAction?: boolean;
  noHideOnConfirm?: boolean;
  size?: "sm" | "xl" | "lg";
}

const ConfirmModal: FC<Props & NiceModalHocProps> = NiceModal.create<Props>(
  (props) => {
    const modal = useModal();

    const hide = () => {
      modal.resolve();
      void modal.hide();
    };

    const handleCancel = () => {
      if (props.onCancel) {
        props.onCancel();
      } else {
        hide();
      }
    };

    const handleConfirm = () => {
      props.onConfirm?.();

      if (!props.noHideOnConfirm) {
        hide();
      }
    };

    return (
      <KC_Modal
        isOpen={modal.visible}
        onClose={props.onCancel ?? modal.hide}
        header={<KC_Heading2 text={props.title} />}
        footer={
          !!props.hideAction ? (
            <>
              <KC_Button
                isPrimary
                text={tt("ok")}
                type={KC_ButtonType.Button}
                onClick={hide}
                size={KC_ButtonSize.Medium}
                className="w-auto"
              />
            </>
          ) : (
            <>
              <KC_Button
                isInverted
                text={props.cancelLabel ?? tt("cancel")}
                type={KC_ButtonType.Button}
                onClick={handleCancel}
                size={KC_ButtonSize.Medium}
                className="w-auto"
              />
              <KC_Button
                isPrimary
                text={props.confirmLabel ?? tt("confirm")}
                type={KC_ButtonType.Button}
                onClick={handleConfirm}
                size={KC_ButtonSize.Medium}
                className="w-auto"
              />
            </>
          )
        }
      >
        {props.children}
      </KC_Modal>
    );
  }
);

export default ConfirmModal;
